import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AdminService } from './admin.service';
import { UserService } from './user.service';
import { AuthenticationService } from '../components/auth/auth.service';
import { EsriUserService } from './esri-user.service';

@Injectable()
export class AuthGuardService implements CanActivate {

	constructor(
		private router: Router,
		private toastr: ToastrService,
		private adminService: AdminService,
		private authService: AuthenticationService,
		private esriUserService: EsriUserService,
		private userService: UserService
	) { }

	async canActivate(): Promise<boolean> {
			const info = {
				isAuthenticated: false,
				hasSubscription: false
			};

			if (!this.userService.isTokenExpired()) {
				// Token exists => app is authenticated
				info.isAuthenticated = true;
				const userSub = await this.adminService.getPortalUserSubscription();
				if (userSub) {
					this.userService.updateUserInfoFromUserSub(userSub);
					info.hasSubscription = true;
				}
			}
			if (info.isAuthenticated && info.hasSubscription) {
				console.log('App is authenticated & subscribed.');
				// Update auth type
				await this.authService.getAuthType(this.userService.getUserInfo().userEmail);
				// If authType is esri and esriToken doesn't exist, get esriToken
				if (this.authService.authTypeOutput.cusAuth.type === 'Esri' && !this.esriUserService.esriToken) {
					this.authService.authDirect(this.authService.authTypeOutput.cusAuth);
					return false;
				} else {
					return true;
				}
			} else {
				console.log('Auth check failed.');
				// Alert user there is no subscription of this app
				if (info.isAuthenticated && !info.hasSubscription) {
					this.toastr.error('No Subscription.');
				}
				const authTypeOutput = this.authService.authTypeOutput;
				if (!authTypeOutput) {
					this.router.navigate(['auth-direct']);
				} else {
					this.authService.authDirect(authTypeOutput.cusAuth);
				}
				return false;
			}
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/auth-guard.service.ts